var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTunisia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40.0001C31.0455 40.0001 39.9998 31.0458 39.9998 20.0001C39.9998 8.95443 31.0455 0.00012207 19.9998 0.00012207C8.95412 0.00012207 -0.000183105 8.95443 -0.000183105 20.0001C-0.000183105 31.0458 8.95412 40.0001 19.9998 40.0001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 29.5653C25.2827 29.5653 29.5652 25.2828 29.5652 20.0001C29.5652 14.7173 25.2827 10.4348 20 10.4348C14.7172 10.4348 10.4347 14.7173 10.4347 20.0001C10.4347 25.2828 14.7172 29.5653 20 29.5653Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1783 16.3428L22.8192 18.6041L25.4768 17.7424L23.8333 20.0018L25.4741 22.263L22.8174 21.398L21.1739 23.6574L21.1756 20.8636L18.5189 19.9986L21.1766 19.1368L21.1783 16.3428Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1738 25.6523C19.0523 25.6523 16.5217 23.1217 16.5217 20.0001C16.5217 16.8786 19.0523 14.348 22.1738 14.348C23.1471 14.348 24.063 14.594 24.8625 15.0273C23.6082 13.8007 21.893 13.0436 19.9999 13.0436C16.1581 13.0436 13.0435 16.1581 13.0435 20.0001C13.0435 23.842 16.1581 26.9565 19.9999 26.9565C21.893 26.9565 23.6083 26.1994 24.8625 24.9728C24.063 25.4062 23.1471 25.6523 22.1738 25.6523Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTunisia);
export default __webpack_public_path__ + "static/media/tunisia.5977e58ca34bd43c4ce6e1f706935e5e.svg";
export { ForwardRef as ReactComponent };